import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import NotificationProvider from "components/NotificationProvider";
import { reservationDocumentTypes } from "features/Reservation/reservationConsts";
import AttachmentsView from "features/attachments/AttachmentsView";
import { AttachmentEntityTypes } from "features/attachments/attachmentsConsts";
import { useGetDocumentTypesQuery } from "features/vehicles/vehicleSlice";
import { useAddDocReservationMutation, useDeleteDocReservationMutation } from "../../../reservationSlice";
import DocumentForReservation from "./DocumentForReservation";
import { ReservationDocumentsStyle } from "./ReservationDocumentsStyle";

const ReservationDocuments = ({ reservation }) => {
    const classes = ReservationDocumentsStyle();
    const [addAttachment, { isLoading: uploadingAttachment }] = useAddDocReservationMutation();
    const [deleteAttachment, { isLoading: deleteAttachmentLoad }] = useDeleteDocReservationMutation();

    let { data: documentTypes, error: documentTypeError, isLoading: isLoadingDocumentTypes } = useGetDocumentTypesQuery();
    documentTypes = documentTypes || [];

    const uploadAttachment = async (type, file, backup) => {
        let fileBase64 = "";
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
            fileBase64 = reader.result.toString().replace(/^data:(.*,)?/, '');
            const result = await addAttachment({
                reservationId: reservation?.id,
                fileType: file.type,
                filedata: fileBase64,
                docName: type,
                "fileName": file.name,
                reservation: reservation,
                backup: backup
            })
            if (result.error) {
                NotificationProvider.error(`Failed to upload the ${label}`);
            } else {
                NotificationProvider.success(`Successfully uploaded the  ${label}`);
            }
        };
    };

    const onDelete = async (type, img) => {
        const body = {
            id: reservation?.id,
            agreementDocUrl: reservation.agreementDocUrl,
            achDocUrl: reservation.achDocUrl,
            coiDocUrl: reservation.coiDocUrl
        }
        body[type] = null;
        const res = await deleteAttachment(body);
        if (res.error) {
            NotificationProvider.error("Failed to delete the attachment");
        } else {
            NotificationProvider.success("Successfully deleted the attachment");
        }
    }
    const label = "Attachment";
    return (
        <div className={classes.documentsWrapper}>
            <DocumentForReservation 
                onSave={(file, backup) => uploadAttachment("coi", file, backup)} 
                onDelete={(img) => onDelete("coiDocUrl", img)} 
                type={reservationDocumentTypes.COI}
                uploadingAttachment={uploadingAttachment} 
                img={{ url: reservation.coiDocUrl, id: reservation?.id, "docName": "COI" }} 
                selectFile={reservation.coiDocUrl != null}
                documentTypes={documentTypes}>
            </DocumentForReservation>
            <Authorize profile={permissionProfiles.RESERVATIONS.VIEW_BANKING_INFO}
                readonlyComponent={<DocumentForReservation 
                    onSave={(file) => uploadAttachment("ach", file)} 
                    onDelete={(img) => onDelete("achDocUrl", img)} 
                    type={reservationDocumentTypes.ACHAuthorizationForm}
                    uploadingAttachment={uploadingAttachment} 
                    img={{ url: reservation.achDocUrl, id: reservation?.id, "docName": "ACH Authorization Form" }} 
                    selectFile={reservation.achDocUrl != null} 
                    confirmBackup={false} 
                    permissionViewEditFile={false}
                    documentTypes={documentTypes}>
                </DocumentForReservation>}
            >
                <DocumentForReservation 
                    onSave={(file) => uploadAttachment("ach", file)} 
                    onDelete={(img) => onDelete("achDocUrl", img)} 
                    type={reservationDocumentTypes.ACHAuthorizationForm}
                    uploadingAttachment={uploadingAttachment} 
                    img={{ url: reservation.achDocUrl, id: reservation?.id, "docName": "ACH Authorization Form" }} 
                    selectFile={reservation.achDocUrl != null} confirmBackup={false}
                    documentTypes={documentTypes}>
                </DocumentForReservation>
            </Authorize>
            <DocumentForReservation 
                onSave={(file, backup) => uploadAttachment("agreement", file, backup)} 
                onDelete={(img) => onDelete("agreementDocUrl", img)} 
                type={reservationDocumentTypes.RentalAgreement}
                uploadingAttachment={uploadingAttachment} 
                img={{ url: reservation.agreementDocUrl, id: reservation?.id, "docName": "Rental Agreement" }} 
                selectFile={reservation.agreementDocUrl != null}
                documentTypes={documentTypes}>
            </DocumentForReservation>
            <div className={classes.boxTitle}>
                {'Documents'}
            </div>
            <AttachmentsView
                entityId={reservation?.id}
                entityType={AttachmentEntityTypes.RESERVATION}
                label='Document'
                addPermissionProfile={permissionProfiles.RESERVATIONS.EDIT}
                permissionDeleteImage={permissionProfiles.RESERVATIONS.EDIT}
            />
        </div>
    )
};

export default ReservationDocuments;
